import React from 'react';
import './UploadProgressBar.scss'; // или модуль

const UploadProgressBar = ({
    status = 'idle', // 'loading', 'success', 'error', 'idle'
    progress = 0,
    fileName = '',
    fileSize = '',
    uploadedSize = '',
    onCancel,
    onRetry,
}) => {
    // Форматирование размера, если передан в байтах (можно опционально)
    return (
        status !== 'idle' ?
            <div className={`upload-progress-bar upload-progress-bar--${status}`}>
                {fileSize && (
                    <span className="upload-progress-bar__size">
                        {uploadedSize || '0'} / {fileSize}
                    </span>
                )}

                <div className="upload-progress-bar__track">
                    <div
                        className="upload-progress-bar__fill"
                        style={{ width: `${progress}%` }}
                    >
                        <div className="upload-progress-bar__glow"></div>
                    </div>
                </div>

                <div className="upload-progress-bar__footer">
                    {(status && fileName) && <div className="upload-progress-bar__info">
                        {fileName && <span className="upload-progress-bar__filename">{fileName}</span>}
                        {status === 'success' && (
                            <span className="upload-progress-bar__success-icon">✓</span>
                        )}
                        {status === 'error' && (
                            <span className="upload-progress-bar__error-icon">✕</span>
                        )}
                    </div>}

                    {status && <div className="upload-progress-bar__actions">
                        {status === 'loading' && onCancel && (
                            <button className="upload-progress-bar__cancel" onClick={onCancel}>
                                Отмена
                            </button>
                        )}
                        {status === 'error' && onRetry && (
                            <button className="upload-progress-bar__retry" onClick={onRetry}>
                                Повторить
                            </button>
                        )}
                        {status === 'success' && (
                            <button className="upload-progress-bar__close" onClick={onCancel /* можно передать функцию скрытия */}>
                                ✕
                            </button>
                        )}
                    </div>}
                </div>
            </div>
            : null
    );
};

export default UploadProgressBar;